import { publish, subscribe } from '../2-utilities/event';
import { forEach } from 'lodash';
import { queryAncestor } from '../2-utilities/dom';

import {
    YEAR_SELECTED as yearSelected,
    MARKERS_PLACED as markersPlaced,
    MARKER_DESELECTED,
    QUIT_AUTOPLAY as quitAutoplay,
    SEARCH_OPENED,
    SEARCH_ENTERED,
    ROW_CLICKED
} from '../3-data/consts/eventNames';

const moduleName = 'search',
    baseSelector = `.js-${moduleName}`,
    toggleSelector = `${baseSelector}-toggle`,
    inputSelector = `${baseSelector}-input`,
    shimSelector = `${baseSelector}-shim`,
    valueSelector = `${baseSelector}-value`,
    suggesterSelector = `${baseSelector}-suggester`,
    baseEl = document.querySelector(baseSelector),
    toggleEl = document.querySelector(toggleSelector),
    inputEl = document.querySelector(inputSelector),
    shimEl = document.querySelector(shimSelector),
    valueEl = document.querySelector(valueSelector),
    suggesterEl = document.querySelector(suggesterSelector),
    hiddenClassName = 'hidden',
    hideClassName = '--hide';

let filterString = '',
    hiddenMarkers = [];

function onYearSelected() {
    inputEl.value = '';
    valueEl.innerHTML = '';
    filterString = '';
}

function onHidePopup() {
    hiddenMarkers = [];
    const markers = document.querySelectorAll('.js-marker');

    inputEl.value = '';
    valueEl.innerHTML = '';
    filterString = '';

    forEach(markers, toggleMarker);
}

function onRowClicked() {
    const markers = document.querySelectorAll('.js-marker');

    inputEl.value = '';
    valueEl.innerHTML = '';
    filterString = '';

    forEach(markers, toggleMarker);
}

function toggleSearch() {
    publish(quitAutoplay);

    if (baseEl.classList.contains(hiddenClassName)) {
        baseEl.classList.remove(hiddenClassName);
        shimEl.classList.remove(hiddenClassName);

        const markers = document.querySelectorAll('.js-marker');

        inputEl.value = '';
        valueEl.innerHTML = '';
        filterString = '';
        inputEl.focus();

        forEach(markers, toggleMarker);

        publish(SEARCH_OPENED);

        return;
    }

    baseEl.classList.add(hiddenClassName);
    shimEl.classList.add(hiddenClassName);

    window.scrollTo(0, 0);
    inputEl.blur();
}

function toggleMarker(marker) {
    marker.classList.remove(hideClassName);

    const name = marker.getAttribute('data-name').toLocaleLowerCase(),
        city = marker.getAttribute('data-city').toLocaleLowerCase();

    if (
        !name.startsWith(filterString) &&
        !city.startsWith(filterString)
    ) {
        marker.classList.add(hideClassName);
        hiddenMarkers.push(marker);
    }

    const nameSlice = name.slice(filterString.length);

    if (name.startsWith(filterString) && filterString.length) {
        suggesterEl.innerHTML = nameSlice;

        return;
    }

    const citySlice = city.slice(filterString.length);

    if (city.startsWith(filterString) && filterString.length) {
        suggesterEl.innerHTML = citySlice;
    }
}

function onChange() {
    hiddenMarkers = [];

    const value = inputEl.value || '',
        markers = document.querySelectorAll('.js-marker');

    if (value === ' ') {
        inputEl.value = '';

        return;
    }

    filterString = value.toLocaleLowerCase();

    if (value) {
        valueEl.innerHTML = value;
        suggesterEl.style.left = valueEl.clientWidth + 'px';
    } else {
        suggesterEl.innerHTML = '';
    }

    forEach(markers, toggleMarker);

    if (markers.length === hiddenMarkers.length) {
        suggesterEl.innerHTML = '';
    }
}

function setup() {
    inputEl.addEventListener('input', onChange);
    inputEl.addEventListener('focusout', (e) => {
        inputEl.value = inputEl.value + suggesterEl.innerHTML;
        suggesterEl.innerHTML = '';

        inputEl.value = inputEl.value.trim();

        onChange();

        const visibleMarkers = document.querySelectorAll(`.js-marker:not(.${hideClassName})`);

        if (visibleMarkers.length === 1) {
            publish(SEARCH_ENTERED, { marker: visibleMarkers[0] });
        }

        toggleSearch();
    });

    inputEl.addEventListener('keyup', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'Enter') {
            return;
        }

        if (e.key === 'ArrowRight') {
            inputEl.value = inputEl.value + suggesterEl.innerHTML;
            suggesterEl.innerHTML = '';

            inputEl.value = inputEl.value.trim();

            onChange();
        }

        if (e.key === 'Enter') {
            inputEl.value = inputEl.value + suggesterEl.innerHTML;
            suggesterEl.innerHTML = '';

            inputEl.value = inputEl.value.trim();

            onChange();

            const visibleMarkers = document.querySelectorAll(`.js-marker:not(.${hideClassName})`);

            if (visibleMarkers.length === 1) {
                publish(SEARCH_ENTERED, { marker: visibleMarkers[0] });
            }

            inputEl.blur();
        }
    })
}

function init() {
    if (toggleEl && baseEl) {
        toggleEl.addEventListener('click', toggleSearch);
        shimEl.addEventListener('click', toggleSearch);

        document.body.addEventListener('click', (e) => {
            const element = document.querySelector(baseSelector);

            if (element.classList.contains(hiddenClassName)) {
                return;
            }

            if (!queryAncestor(e.target, baseSelector) && !queryAncestor(e.target, toggleSelector)) {
                element.classList.add(hiddenClassName);

                window.scrollTo(0, 0);
                inputEl.blur();
            }
        });

        setup();
    }
}

init();
subscribe(yearSelected, onYearSelected);
subscribe(ROW_CLICKED, onRowClicked);
subscribe(MARKER_DESELECTED, onHidePopup);
